import { Component } from '@angular/core';

@Component({
  selector: 'app-webfooter',
  templateUrl: './webfooter.component.html'
})
export class WebfooterComponent {

}
